import type { User } from "../../types"

const LS_KEY = 'tuser'

export const getUserFromStorage = (): User | null => {
  const userLs = localStorage.getItem(LS_KEY)
  if (!userLs) return null

  try {
    const parsedData = JSON.parse(userLs)
    return parsedData.id ? parsedData : null
  } catch {
    localStorage.removeItem(LS_KEY)
    return null
  }
}

export const setUserInStorage = (user: User | null): void => {
  if (user) {
    localStorage.setItem(LS_KEY, JSON.stringify(user))
  } else {
    localStorage.removeItem(LS_KEY)
  }
}
